import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for casino reports.
 * @extends JetView
 */
export default class tableInformeCasinoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            view: 'treetable', // Treetable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            scheme: {
                $group: {
                    by: 'Punto', // Grouping by 'Punto'
                },
            },
            bready: function () {
                this.openAll(); // Expand all rows on ready
            },
            footer: true, // Enable footer
            columns: [
                // Column definitions
                {
                    id: 'Fecha', // Column ID
                    header: 'Fecha', // Column header
                    width: 250, // Column width
                    template: function (obj, common) {
                        // Custom template for displaying date
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Group row display
                        return obj.Fecha; // Regular row display
                    },
                    footer: 'Total:', // Footer content
                },
                { id: 'Moneda', header: _('Moneda'), width: 150 }, // Currency column
                {
                    id: 'CantidadJugadas', // Plays count column
                    header: _('Cantidad de Jugadas'),
                    footer: { content: 'summColumn' }, // Footer for summation
                    format: webix.i18n.numberFormat, // Number formatting
                    width: 200,
                },
                {
                    id: 'ValorApostado', // Bet value column
                    header: _('Valor Apostado'),
                    footer: { content: 'summColumn' }, // Footer for summation
                    format: webix.i18n.numberFormat, // Number formatting
                    width: 200,
                },
                {
                    id: 'ValorPremios', // Prize value column
                    header: _('Valor Premios'),
                    footer: { content: 'summColumn' }, // Footer for summation
                    format: webix.i18n.numberFormat, // Number formatting
                    width: 200,
                },
            ],
            autowidth: false, // Disable auto width
            data: [
                // Initial data for the treetable
                {
                    Fecha: '2018-12-26',
                    Moneda: 'PEN',
                    CantidadJugadas: '86',
                    ValorApostado: '20.00',
                    ValorPremios: '0.00',
                },
                {
                    Fecha: '2018-02-26',
                    Moneda: 'PEN',
                    CantidadTickets: '16',
                    ValorEntradasEfectivo: '20.00',
                    ValorEntradasBonoTC: '0.00',
                    ValorEntradasTraslados: '0.00',
                    ValorEntradasRecargas: '0.00',
                    ValorSalidasEfectivo: '20.00	',
                    ValorSalidasTraslados: '2.05	',
                    ValorSalidasNotasRetiro: '0.00',
                    Saldo: '162.00',
                    MMoneda: '168.15',
                    Punto: 'agilomartinez',
                },
                {
                    Fecha: '2018-11-26',
                    Moneda: 'PEN',
                    CantidadTickets: '88',
                    ValorEntradasEfectivo: '10.00',
                    ValorEntradasBonoTC: '0.00',
                    ValorEntradasTraslados: '0.00',
                    ValorEntradasRecargas: '0.00',
                    ValorSalidasEfectivo: '20.00	',
                    ValorSalidasTraslados: '2.05	',
                    ValorSalidasNotasRetiro: '0.00',
                    Saldo: '62.00',
                    MMoneda: '868.15',
                    Punto: 'Abancay - Lima',
                },
            ],
            ready: function () {
                // Event triggered when the view is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                }
            },
            math: true, // Enable math operations
            datafetch: 10, // Number of records to fetch
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var url = grid.data.url; // URL for data loading
        grid.clearAll(); // Clear existing data

        // Event listener for filtering data
        this.on(this.app, 'flujoCajaResumido:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to query string
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
